export default {
  totalDelivery: 'Total Pengiriman',
  totalProcessed: 'Total Diproses',
  totalDelivered: 'Total Terkirim',
  totalFailed: 'Total Gagal',
  successOrder: {
    title: 'Pesanan Berhasil',
    logistic: 'Logistik',
    delivered: 'Berhasil Kirim'
  },
  failedOrder: {
    title: 'Pesanan Gagal',
    logistic: 'Logistik',
    undelivered: 'Gagal Kirim'
  },
  shippingCost: 'Biaya Ongkir',
  thisMonth: 'Bulan Ini',
  lastMonth: 'Bulan Lalu',
  onGoingDeliveries: {
    title: 'Pengiriman Berlangsung',
    date: 'Tgl',
    sender: 'Pengirim',
    senderLocation: 'Lokasi Pengirim',
    receiver: 'Penerima',
    receiverLocation: 'Lokasi Penerima'
  },
  seeAll: 'Lihat Semua'
}
